import * as React from 'react'

import Spinner from '@mulesoft/anypoint-components/lib/Spinner'
import { connect } from 'react-redux'
import { LifecycleValues, selectors as lifcycleSelectors } from '../../lifecycle/lifecycle'
import { AppState } from '../../types'

type ValueProps = {
  initializationState: LifecycleValues,
  error: string
}

export type Props = ValueProps

class LifeCycleErrorChecker extends React.Component<Props> {

  render() {
    const {initializationState, error, children} = this.props

    switch (initializationState) {
      case LifecycleValues.Initializing:
        return (
          <div className="app-loading">
            <Spinner size="m"/>
          </div>
        )

      case LifecycleValues.UnexpectedError:
      case LifecycleValues.InitializeError:
        return (
          <div className="app-error">
            <h3>Oops... Please try again later</h3>
            <p>{error}</p>
          </div>
        )

      case LifecycleValues.Initialized:
      default:
        return children
    }
  }
}

const mapState = (rootState: AppState): ValueProps => ({
  initializationState: lifcycleSelectors.getInitializationState(rootState),
  error: lifcycleSelectors.getInitializationError(rootState)
})

export default connect(mapState)(LifeCycleErrorChecker)
